<router-outlet></router-outlet>

<span *ngIf="manifestVersion" class="version-info">V{{manifestVersion}}</span>